/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu'
import { LinqService, QueryOptions } from 'linquest'
import {
  NotificationPreviewResultDto,
  OneToOneSessionAgendaDto,
  OneToOneSessionAiAssistantStatusDto,
  OneToOneSessionDetailDto,
  OneToOneSessionEmployeeNoteDto,
  OneToOneSessionFormContextDto,
  OneToOneSessionGrowthAreaDto,
  OneToOneSessionIdRequest,
  OneToOneSessionFormDto,
  OneToOneSessionFormInitDto,
  OneToOneSessionListDto,
  OneToOneSessionManagerNoteDto
} from './models'

/**
 * OneToOneSessionApi - API class
 */
export class OneToOneSessionApi extends LinqService {
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  /**
   * @param operationYearId
   */
  listSessionsOfCurrentUser(operationYearId?: string, options?: QueryOptions) {
    const url = `/OneToOneSession/ListSessionsOfCurrentUser`
    let query = this.createQuery<OneToOneSessionListDto[]>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (operationYearId) {
      options.params.push({ key: 'operationYearId', value: operationYearId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  getOneToOneSessionRequest(options?: QueryOptions) {
    const url = `/OneToOneSession/GetOneToOneSessionRequest`
    let query = this.createQuery<OneToOneSessionFormInitDto>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param sessionId
   */
  getSessionDetail(sessionId?: string, options?: QueryOptions) {
    const url = `/OneToOneSession/GetSessionDetail`
    let query = this.createQuery<OneToOneSessionDetailDto>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (sessionId) {
      options.params.push({ key: 'sessionId', value: sessionId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param sessionId
   */
  getSessionFormContext(sessionId?: string, options?: QueryOptions) {
    const url = `/OneToOneSession/GetSessionFormContext`
    let query = this.createQuery<OneToOneSessionFormContextDto>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (sessionId) {
      options.params.push({ key: 'sessionId', value: sessionId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param dto
   */
  addOrUpdateSession(dto?: OneToOneSessionFormDto, options?: QueryOptions) {
    const url = `/OneToOneSession/AddOrUpdateSession`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param dto
   */
  previewSession(dto?: OneToOneSessionFormDto, options?: QueryOptions) {
    const url = `/OneToOneSession/PreviewSession`
    let query = this.createQuery<NotificationPreviewResultDto>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteSessionAsync(id?: string, options?: QueryOptions) {
    const url = `/OneToOneSession/DeleteAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param sessionId
   */
  getNotesBySessionId(sessionId?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionEmployeeNote/GetNotesBySessionId`
    let query = this.createQuery<OneToOneSessionEmployeeNoteDto[]>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (sessionId) {
      options.params.push({ key: 'sessionId', value: sessionId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param dto
   */
  saveNoteAsync(dto?: OneToOneSessionEmployeeNoteDto, options?: QueryOptions) {
    const url = `/OneToOneSessionEmployeeNote/SaveAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteNoteAsync(id?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionEmployeeNote/DeleteAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param sessionId
   */
  getManagerNotesBySessionId(sessionId?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionManagerNote/GetNotesBySessionId`
    let query = this.createQuery<OneToOneSessionManagerNoteDto[]>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (sessionId) {
      options.params.push({ key: 'sessionId', value: sessionId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param dto
   */
  saveManagerNoteAsync(dto?: OneToOneSessionManagerNoteDto, options?: QueryOptions) {
    const url = `/OneToOneSessionManagerNote/SaveAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param request
   */
  getAiAssistantStatus(request?: OneToOneSessionIdRequest, options?: QueryOptions) {
    const url = `/OneToOneSessionAiMeetingAssistant/GetAssistantStatus`
    let query = this.createQuery<OneToOneSessionAiAssistantStatusDto>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = request
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteManagerNoteAsync(id?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionManagerNote/DeleteAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param sessionId
   */
  getAgendaBySessionId(sessionId?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionAgenda/GetAgendaBySessionId`
    let query = this.createQuery<OneToOneSessionAgendaDto[]>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (sessionId) {
      options.params.push({ key: 'sessionId', value: sessionId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param dto
   */
  saveAgendaAsync(dto?: OneToOneSessionAgendaDto, options?: QueryOptions) {
    const url = `/OneToOneSessionAgenda/SaveAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteAgendaAsync(id?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionAgenda/DeleteAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param agendaId
   */
  toggleAgendaStatus(agendaId?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionAgenda/ToggleStatus`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'PUT'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (agendaId) {
      options.params.push({ key: 'agendaId', value: agendaId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param sessionId
   */
  completeSession(sessionId?: string, options?: QueryOptions) {
    const url = `/OneToOneSession/CompleteSession`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.params.push({ key: 'sessionId', value: sessionId && sessionId.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param sessionId
   */
  getGrowthAreasOfSession(sessionId?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionGrowthArea/GetGrowthAreaInformationsOfSession`
    let query = this.createQuery<OneToOneSessionGrowthAreaDto[]>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    if (sessionId) {
      options.params.push({ key: 'sessionId', value: sessionId })
    }

    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param dto
   */
  saveGrowthAreaAsync(dto?: OneToOneSessionGrowthAreaDto, options?: QueryOptions) {
    const url = `/OneToOneSessionGrowthArea/SaveAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param growthAreaId
   */
  toggleGrowthAreaCompleted(growthAreaId?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionGrowthArea/ToggleIsCompleted`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.data = { growthAreaId }
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteGrowthAreaAsync(id?: string, options?: QueryOptions) {
    const url = `/OneToOneSessionGrowthArea/DeleteAsync`
    let query = this.createQuery<any>(url)

    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }
}
